import React from 'react';
import { Grid, Paper, Typography, Button } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';

const ResizedImageCard = ({ img, calculateReduction, formatDimensions, downloadSingleImage }) => {
    const { text, color } = calculateReduction(img.originalSize, img.resizedSize);

    return (
        <Grid item xs={12} sm={6} md={4} lg={3}>
            <Paper elevation={3} sx={{ p: 2, textAlign: 'center' }}>
                {/* ✅ プレビュー画像 */}
                <img 
                    src={img.url} 
                    alt={img.name} 
                    style={{ 
                        width: '200px',        
                        height: '150px',       
                        objectFit: 'contain',  
                        borderRadius: '8px'    
                    }} 
                />
                <Typography variant="body1" sx={{ mt: 1 }}>
                    <strong>{img.name}</strong>（{formatDimensions(img.width, img.height)}）
                </Typography>
                {/* ✅ サイズ増減の表示 */}
                <Typography variant="body2" sx={{ color }}>
                    {text}
                </Typography>
                <Button 
                    variant="contained" 
                    color="secondary"
                    startIcon={<DownloadIcon />}
                    onClick={() => downloadSingleImage(img)}
                    sx={{ mt: 2 }}
                >
                    個別ダウンロード
                </Button>
            </Paper>
        </Grid>
    );
};

export default ResizedImageCard;
